import React, { useEffect } from "react";
import { initInclusiveScripts } from "./utils/inclusiveScripts";
import "./inclusivePanel.scss";

// Заміни імпорти іконок на свої шляхи якщо потрібно
import playIcon from "../../assets/images/inclusive-play.svg";
import pauseIcon from "../../assets/images/inclusive-pause.svg";
import volumeIcon from "../../assets/images/inclusive-volume.svg";
import repeatIcon from "../../assets/images/inclusive-repeat.svg";
import crossIcon from "../../assets/images/inclusive-cross.svg";
import eyeIcon from "../../assets/images/inclusive-eye.svg";
import audioInclusive from "../../assets/audio_inclusive.mp3";
export default function InclusivePanel({
  isOpenInclusive,
  setIsStickyInclusive,
  isStickyInclusive,
  setIsOpenInclusive,
}) {
  console.log("window", window);
  useEffect(() => {
    // ініціалізуємо логіку (отримуємо cleanup)
    var cleanup = null;
    try {
      cleanup = initInclusiveScripts();
    } catch (e) {
      // якщо щось не так — все одно продовжуємо
      // console.error(e);
    }
    return () => {
      if (typeof cleanup === "function") cleanup();
    };
  }, []);

  return (
    <div>
      {/* Кнопка "око" в хедері (React керує відкриттям) */}
      {/*<button*/}
      {/*  id="web_eye_togler"*/}
      {/*  className="inclusive-eye-button"*/}
      {/*  onClick={() => setIsOpen((s) => !s)}*/}
      {/*  aria-label="Toggle inclusive panel"*/}
      {/*>*/}
      {/*  <img src={eyeIcon} alt="Inclusive eye" />*/}
      {/*</button>*/}

      {/* Панель (десктоп) */}
      <div
        className={`inclusive-panel ${
          isOpenInclusive ? "inclusive-panel-open" : ""
        } ${
          isStickyInclusive ? "inclusive-panel-sticky" : ""
        } isnt-visible-on-mob`}
        id="sg_header"
      >
        <div className="inclusive-panel-container">
          <div className="inclusive-panel-toggles">
            {/* Колірна гама */}
            <div className="inclusive-panel-colors">
              <div className="inclusive-panel-colors-title">Колір</div>
              <div className="inclusive-panel-colors-btns">
                <button
                  id="inclusive_blue"
                  className="inclusive-panel-colors-btns-item inclusive-panel-colors-btns-item-active"
                  aria-label="Blue theme"
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 64 64"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="30"
                      cy="30"
                      r="29"
                      fill="#004B9B"
                      stroke="#004B9B"
                      strokeWidth="2"
                    />
                    <circle cx="30" cy="30" r="15" fill="#5BC4F1" />
                  </svg>
                </button>
                <button
                  id="inclusive_monochrome"
                  className="inclusive-panel-colors-btns-item"
                  aria-label="Monochrome theme"
                >
                  <svg width="30" height="30" viewBox="0 0 64 64">
                    <circle
                      cx="30"
                      cy="30"
                      r="29"
                      fill="#ffffff"
                      stroke="#ffffff"
                      strokeWidth="2"
                    />
                    <circle cx="30" cy="30" r="15" fill="#000000" />
                  </svg>
                </button>
                <button
                  id="inclusive_dark"
                  className="inclusive-panel-colors-btns-item"
                  aria-label="Dark theme"
                >
                  <svg width="30" height="30" viewBox="0 0 64 64">
                    <circle
                      cx="30"
                      cy="30"
                      r="29"
                      fill="#000000"
                      stroke="#000000"
                      strokeWidth="2"
                    />
                    <circle cx="30" cy="30" r="15" fill="#FFFFFF" />
                  </svg>
                </button>
              </div>
            </div>

            <hr />

            {/* Розмір шрифта */}
            <div className="inclusive-panel-size">
              <div className="inclusive-panel-size-title">Розмір</div>
              <div className="inclusive-panel-size-btns">
                <button
                  id="font-default"
                  className="inclusive-panel-size-btns-item inclusive-panel-size-btns-item-active"
                  aria-label="Default font"
                >
                  А1
                </button>
                <button
                  id="font-big"
                  className="inclusive-panel-size-btns-item"
                  aria-label="Big font"
                >
                  А2
                </button>
                <button
                  id="font-large"
                  className="inclusive-panel-size-btns-item"
                  aria-label="Large font"
                >
                  А3
                </button>
              </div>
            </div>

            <hr />

            {/* Зображення */}
            <div className="inclusive-panel-pictures">
              <div className="inclusive-panel-pictures-title">Зображення</div>
              <div className="inclusive-panel-pictures-toggle">
                <label className="inclusive-panel-pictures-toggle-toggler">
                  <input
                    id="inclusive_images_checkbox"
                    type="checkbox"
                    className="inclusive-panel-pictures-toggle-toggler-checkbox"
                  />
                  <span className="inclusive-panel-pictures-toggle-toggler-slider"></span>
                </label>
              </div>
            </div>
          </div>

          {/* Кнопки керування */}
          <div className="inclusive-panel-control">
            <button
              id="hide_panel_controls"
              className="inclusive-panel-control-btn"
              onClick={() => {
                setIsStickyInclusive(false);
                setIsOpenInclusive(false);
              }}
            >
              <span>Сховати</span>
              <img src={crossIcon} alt="close" data-not-hide-image />
            </button>
            <button
              id="remove_all_inclusive_settings"
              className="inclusive-panel-control-btn"
            >
              <span>Скинути</span>
              <img src={repeatIcon} alt="reset" data-not-hide-image />
            </button>
          </div>

          {/* Аудіо-плеєр (десктоп) */}
          <div className="inclusive-panel-rozkrytta">
            <div className="inclusive-panel-rozkrytta-player">
              <div className="controls">
                <div className="progress">
                  <p className="progress-title">Розкриття інформації</p>
                  <div className="progress-row">
                    <button
                      id="play-pause"
                      className="play"
                      aria-label="Play/Pause"
                    >
                      <img
                        id="icon-play"
                        src={playIcon}
                        alt="play"
                        data-not-hide-image
                      />
                      <img
                        id="icon-pause"
                        src={pauseIcon}
                        alt="pause"
                        data-not-hide-image
                      />
                    </button>
                    <span id="current-time">0:00</span>
                    <div className="progress-container" id="progress-container">
                      <div className="progress-bar" id="progress-bar"></div>
                    </div>
                  </div>
                </div>

                <div className="volume-section">
                  <div className="volume-bar-info">
                    <img src={volumeIcon} alt="volume" data-not-hide-image />
                    <span id="volume-text">70%</span>
                  </div>
                  <div className="volume-lines">
                    <div className="volume-bar-container" id="volume-container">
                      <div className="volume-bar" id="volume-bar"></div>
                    </div>
                  </div>
                </div>
              </div>
              <audio id="audio" src={audioInclusive} preload="metadata"></audio>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// src/components/inclusive/InclusivePanel.jsx